define('plugin/product/view/ProductIndexListView',['require','lib/view/BaseCollectionView','plugin/product/view/ProductIndexItemView','view/controller/error/ErrorView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var ProductIndexItemView = require('plugin/product/view/ProductIndexItemView');
    var ErrorView = require('view/controller/error/ErrorView');

    return Parent.extend({

        _pageId: 'product',

        // emptyView: ErrorView,
        getEmptyView: function () {
            if (this.collection.isLoaded()) {
                return ErrorView
            } else {
                return undefined
            }
        },
        childView: ProductIndexItemView,

        childViewOptions: function () {
            return {
                cart: this.getOption('cart')
            }
        },

        emptyViewOptions: function () {
            return {
                type: '404'
            }
        },

        safeRender: function (event) {
            if (!this.isDestroyed) {
                this.render();
            }
        },
        
    });

});
